import React from "react";
import { Col, Row } from "antd";
import { MatApoyo } from "../Generals";

export default function Lesson7({ data, setLoading }) {
  return (
    <div className="texto_parrafo">
      <p>
        Los delitos electorales son aquellas acciones u omisiones descritas y sancionadas por la Ley General en Materia de 
        Delitos Electorales, que lesionan o ponen en peligro el correcto desarrollo de la función electoral y atentan contra 
        las características del voto, el cual debe ser universal, libre, directo, personal, secreto e intransferible. 
      </p>
      <p>
        Entre los principales delitos se encuentran:
      </p>
      <div className="listPuntoRosa">
        La <b>compra del voto.</b> . Se refiere al desvío de recursos públicos por parte de autoridades gubernamentales o 
        partidos políticos para comprar la orientación del voto.
      </div>
      <div className="listPuntoRosa">
        La <b>coacción del voto.</b> Sucede cuando una persona, grupo o institución ejerce presiones de cualquier tipo 
        sobre las o los ciudadanos para limitar u orientar la emisión de su voto.
      </div>
      <br/>
      <p>
        Además de las anteriores, hay otras conductas que se encuentran tipificadas como delitos electorales. En el siguiente material de 
        apoyo podrás conocer algunos de los delitos electorales.
      </p>
      {data && data.indexOf(7) && <MatApoyo array={[data[7]]} />}
      <p>
        Cualquier persona que incurra en alguna o varias de estas conductas estaría cometiendo un delito electoral; además, existen tipos 
        penales que se han reservado para personas que tienen una calidad especial, por ejemplo: servidoras/es públicas/os, funcionarias/os 
        electorales, funcionarias/os partidistas, precandidatas/os, candidatas/os y candidatas/os electas, por lo que la sanción a quienes 
        realicen alguna de las conductas antes enlistadas dependerá del delito cometido. 
      </p>
      <p>  
        Es importante que sepas que a aquella persona que cometa un delito electoral se le impondrán sanciones como:
      </p>
      <p>
        <div className="listPuntoRosa">La pérdida del derecho al voto activo y pasivo</div>
        <div className="listPuntoRosa">La suspensión de sus derechos políticos</div>
        <div className="listPuntoRosa">Multa y privación de la libertad</div>
      </p>
      <p>
        Tratándose de servidoras/es públicas/os que cometan delitos electorales, se les impondrá, además de la sanción 
        correspondiente, la inhabilitación (de dos a seis años) para ocupar un empleo, cargo o comisión en el servicio 
        público federal, local, municipal o de la Ciudad de México y, en su caso, la destitución del cargo.
      </p>
      <p>
        Revisa el siguiente material donde podrás conocer las características de la denuncia de un delito electoral.
      </p>
      {data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}
      <p>
        Antes de realizar la actividad de repaso revisa el siguiente video.
        <br/>
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}
      <p>
        <br/>
        Ahora es momento de repasar lo aprendido, ingresa al siguiente enlace:
        <br/>
      </p>
      {data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}
      <p>
        <br/>
        Para continuar, abordemos el tema de violencia política contra las mujeres en razón de género. ¿Sabías que la clasificación 
        de las diversas modalidades de violencia contra las mujeres atiende al ámbito donde se comete la misma? Ésta puede ser: familiar, 
        laboral, docente, en la comunidad, institucional, política o feminicida.
      </p>
      <p>
        Te invitamos a revisar el siguiente video en el cual describimos las características de la violencia política contra las mujeres 
        en razón de género.
      </p>
      {data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}
      <p>
        La violencia política contra las mujeres en razón de género (VPMRG) puede sancionarse a través de la configuración de diversas 
        conductas establecidas en los ordenamientos penales, electorales y administrativos.
      </p>
      <p>
        Algunos elementos indispensables para considerar que un acto de violencia se basa en el género son:
      </p>
      <p>
        <ol>
          <li>Cuando la violencia se dirige a una mujer por ser mujer.</li>
          <li>Cuando la acción u omisión afecta a las mujeres de forma diferente que a los hombres o cuyas consecuencias se agravan ante 
            la condición de ser mujer.</li>
          <li>Cuando la acción y omisión afecta a las mujeres en mayor proporción que a los hombres.</li>
        </ol>
      </p>
      <p>
        De acuerdo con las expresiones que adquiera la violencia y la competencia de cada instancia, se hará del conocimiento de: 
      </p>
      <p>
          <div className="listPuntoRosa"><b>Instituto Nacional Electoral.</b> Cuando se trate de infracciones a la normativa electoral federal.</div>
          <div className="listPuntoRosa"><b>Organismos Públicos Locales.</b> Cuando se trate de infracciones a la normativa electoral local.</div>
          <div className="listPuntoRosa"><b>Tribunal Electoral del Poder Judicial de la Federación.</b> Cuando se trate de incumplimiento de cualquier obligación electoral.</div>
          <div className="listPuntoRosa"><b>Fiscalía Especializada en materia de Delitos Electorales.</b> Cuando se trate de delitos electorales.</div>
          <div className="listPuntoRosa"><b>Partidos políticos.</b> Cuando se trate de asuntos internos de los propios partidos políticos.</div>
      </p>
      <p>
        En el siguiente material podrás identificar las atribuciones específicas que corresponden a cada autoridad en materia de 
        violencia política contra las mujeres en razón de género.
      </p>
      {data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}
      <p>
        <b>La observación electoral desempeña un papel fundamental en la prevención y erradicación de los delitos electorales, dado que:</b>
      </p>
      <Row>
        <Col span={1} className="margenLista">
        <b>{"a)"}</b>
        </Col>
        <Col span={20}>
          Tiene un efecto de disuasión en quienes se interesan en llevar a cabo prácticas irregulares o delictivas
        </Col>
      </Row>
      <Row>
        <Col span={1} className="margenLista">
        <b>{"b)"}</b>
        </Col>
        <Col span={20}>
          Permite obtener información sobre las características de las formas de manipulación del voto. 
        </Col>
      </Row>
      <Row>
        <Col span={1} className="margenLista" >
        <b>{"c)"}</b>
        </Col>
        <Col span={20}>
          Proporciona insumos para comprender el fenómeno y diseñar políticas públicas para prevenirlo y erradicarlo.
        </Col>
      </Row>
      <Row>
        <Col span={1} className="margenLista">
        <b>{"d)"}</b>
        </Col>
        <Col span={20}>
          Genera confianza y credibilidad en las instituciones y en los procesos electorales.
        </Col>
      </Row>
      <Row>
        <Col span={1} className="margenLista">
        <b>{"e)"}</b>
        </Col>
        <Col span={20}>
          Contribuye a fortalecer la democracia y la paz social.
        </Col>
      </Row>
      <br/>
      <p>
        Es importante que, frente a cualquier conducta que pudiera constituir un delito electoral,  <b className="underline">se denuncie</b> 
        ante la Fiscalía Especializada en materia de Delitos Electorales o ante la autoridad electoral local correspondiente.
      </p>
      <p>
        Las y los observadores electorales contribuyen a la certeza y a que todo marche conforme a derecho, lo cual implica la responsabilidad 
        de denunciar si se presencia un delito electoral, una situación de violencia política contra las mujeres en razón de género o cualquier 
        situación que no se realice conforme a la ley.
      </p>
      <p>
        No olvides consultar el <b className="textoResaltado2">CAPÍTULO 7 DE TU {data && data.indexOf(8) && <MatApoyo array={[data[8]]} tipo={1}/>}</b> que 
        está disponible en los materiales de consulta de este curso, así como el siguiente material de apoyo para que refuerces tus conocimientos. 
      </p>
      {data && data.indexOf(7) && <MatApoyo array={[data[7]]}/>}
      <p>
        Ya que conoces la importancia de tu labor ayúdanos a evitar que se cometan delitos electorales. <b>¡Denuncia cualquier delito que presencies!, 
          ¡tu aportación cuenta, no basta con observar, hay que actuar!</b>
      </p>
      <p>
        Ahora ya puedes realizar la actividad de evaluación de esta lección. 
      </p>
    </div>
  );
}
